<template>
  <v-card class="padding">
    <!--edição -->
    <v-dialog v-model="form" persistent max-width="700">
      <v-card>
        <v-card-text>
          <v-layout justify-space-between row wrap>
            <v-flex md5>
              <v-text-field
                ref="nome"
                :rules="[() =&gt; !!agenteSelected.nome || 'Este campo é obrigatório']"
                v-model="agenteSelected.nome"
                placeholder="Nome"
                label="Nome"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md5>
              <v-text-field
                ref="email"
                :rules="[() =&gt; /^[a-z0-9._]+@[a-z0-9]+.[a-z]+(.[a-z]+)?$/i.test(agenteSelected.login) || 'Informe um e-mail válido']"
                v-model="agenteSelected.login"
                placeholder="E-mail"
                label="E-mail"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between row wrap>
            <v-flex md5>
              <v-text-field
                ref="logradouro"
                :rules="[() =&gt; !!agenteSelected.endereco.logradouro || 'Este campo é obrigatório']"
                v-model="agenteSelected.endereco.logradouro"
                placeholder="Logradouro"
                label="Logradouro"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md5>
              <v-text-field
                ref="numero"
                :rules="[() =&gt; !!agenteSelected.endereco.numero || 'Este campo é obrigatório']"
                v-model="agenteSelected.endereco.numero"
                placeholder="Número"
                label="Número"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between row wrap>
            <v-flex md5>
              <v-text-field
                ref="bairro"
                :rules="[() =&gt; !!agenteSelected.endereco.bairro || 'Este campo é obrigatório']"
                v-model="agenteSelected.endereco.bairro"
                placeholder="Bairro"
                label="Bairro"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md5>
              <v-text-field
                ref="cidade"
                :rules="[() =&gt; !!agenteSelected.endereco.cidade || 'Este campo é obrigatório']"
                v-model="agenteSelected.endereco.cidade"
                placeholder="Cidade"
                label="Cidade"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between row wrap>
            <v-flex md5>
              <v-text-field
                ref="estado"
                v-model="agenteSelected.endereco.estado"
                placeholder="Estado"
                required
                label="Estado"
                color="blue-grey"
              ></v-text-field>
            </v-flex>
            <v-flex md5>
              <v-text-field
                @keypress="formatar('#####-###', $event)"
                ref="cep Ex: #####-###"
                :rules="[() =&gt; /^[0-9]{5}-[0-9]{3}$/.test(this.agenteSelected.endereco.cep) || 'Informe um cep válido' ]"
                v-model="agenteSelected.endereco.cep"
                placeholder="Cep Ex: #####-###"
                required
                label="Cep Ex: #####-###"
                color="blue-grey"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-text-field
            ref="password"
            placeholder="password"
            label="password"
            color="blue-grey"
            v-model="agenteSelected.senha"
          ></v-text-field>

          <v-select
            v-model="agenteSelected.grupo_id"
            item-text="nome"
            color="blue-grey"
            item-value="_id"
            :items="getGruposPxTalk"
            label="Selecione o Grupo"
          ></v-select>
          <v-text-field
            ref="telefonesadd"
            placeholder="Adicionar Telefone"
            label="Informe o telefone e pressione enter"
            v-model="tempfone"
            @keyup.enter="agenteSelected.telefones.push(tempfone), tempfone=''"
            color="blue-grey"
          ></v-text-field>
          <v-chip :key="i" v-for="(t, i) in agenteSelected.telefones">
            {{ t }}
            <v-icon @click="agenteSelected.telefones.splice(i, 1)" right>clear</v-icon>
          </v-chip>
          <v-divider></v-divider>
          <v-btn outline color="error" @click="form=false">Cancelar</v-btn>
          <v-btn
            outline
            color="blue-grey"
            @click="update(agenteSelected)"
            :disabled="!validate"
            dark
          >{{ agenteSelected._id ? &apos;Alterar&apos; : &apos;Cadastrar&apos; }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- cadastro -->
    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card>
        <v-card-text>
          <v-layout justify-space-between row wrap>
            <v-flex md5>
              <v-text-field
                ref="nome"
                :rules="[() =&gt; !!agenteSelected.nome || 'Este campo é obrigatório']"
                v-model="agenteSelected.nome"
                placeholder="Nome"
                label="Nome"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md5>
              <v-text-field
                ref="email"
                :rules="[() =&gt; /^[a-z0-9._]+@[a-z0-9]+.[a-z]+(.[a-z]+)?$/i.test(agenteSelected.login) || 'Informe um e-mail válido']"
                v-model="agenteSelected.login"
                placeholder="E-mail"
                label="E-mail"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between row wrap>
            <v-flex md5>
              <v-text-field
                ref="logradouro"
                :rules="[() =&gt; !!agenteSelected.endereco.logradouro || 'Este campo é obrigatório']"
                v-model="agenteSelected.endereco.logradouro"
                placeholder="Logradouro"
                label="Logradouro"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md5>
              <v-text-field
                ref="numero"
                :rules="[() =&gt; !!agenteSelected.endereco.numero || 'Este campo é obrigatório']"
                v-model="agenteSelected.endereco.numero"
                placeholder="Número"
                label="Número"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between row wrap>
            <v-flex md5>
              <v-text-field
                ref="bairro"
                :rules="[() =&gt; !!agenteSelected.endereco.bairro || 'Este campo é obrigatório']"
                v-model="agenteSelected.endereco.bairro"
                placeholder="Bairro"
                label="Bairro"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md5>
              <v-text-field
                ref="cidade"
                :rules="[() =&gt; !!agenteSelected.endereco.cidade || 'Este campo é obrigatório']"
                v-model="agenteSelected.endereco.cidade"
                placeholder="Cidade"
                label="Cidade"
                color="blue-grey"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify-space-between row wrap>
            <v-flex md5>
              <v-text-field
                ref="estado"
                v-model="agenteSelected.endereco.estado"
                placeholder="Estado"
                required
                label="Estado"
                color="blue-grey"
              ></v-text-field>
            </v-flex>
            <v-flex md5>
              <v-text-field
                @keypress="formatar('#####-###', $event)"
                ref="cep Ex: #####-###"
                :rules="[() =&gt; /^[0-9]{5}-[0-9]{3}$/.test(this.agenteSelected.endereco.cep) || 'Informe um cep válido' ]"
                v-model="agenteSelected.endereco.cep"
                placeholder="Cep Ex: #####-###"
                required
                label="Cep Ex: #####-###"
                color="blue-grey"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-text-field
            ref="senha"
            placeholder="Senha"
            label="Senha"
            color="blue-grey"
            v-model="agenteSelected.senha"
          ></v-text-field>
          <v-select
            item-text="nome"
            color="blue-grey"
            item-value="_id"
            :items="getGruposPxTalk"
            v-model="agenteSelected.grupo_id"
            label="Selecione o Grupo"
          ></v-select>
          <v-text-field
            ref="telefonesadd"
            placeholder="Adicionar Telefone"
            label="Informe o telefone e pressione enter"
            v-model="tempfone"
            @keyup.enter="agenteSelected.telefones.push(tempfone), tempfone=''"
            color="blue-grey"
          ></v-text-field>
          <v-chip :key="i" v-for="(t, i) in agenteSelected.telefones">
            {{ t }}
            <v-icon @click="agenteSelected.telefones.splice(i, 1)" right>clear</v-icon>
          </v-chip>
          <v-divider></v-divider>
          <v-btn outline color="error" @click="dialog=false">Cancelar</v-btn>
          <v-btn
            outline
            color="blue-grey"
            @click="save(agenteSelected)"
            :disabled="!validate"
            dark
          >{{ agenteSelected._id ? &apos;Alterar&apos; : &apos;Cadastrar&apos; }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <h1 class="fonte">Gerenciamento de Agentes</h1>
    <p class="black--text">Escolha uma ação abaixo</p>
    <v-btn class="white--text" color="fundo" v-if="$can('agentes','cadastraragente')" @click="novo">
      <v-icon>add</v-icon>Cadastrar novo
    </v-btn>
    <v-tooltip color="blue-grey" v-if="!$can('agentes','cadastraragente')" top>
      <v-btn slot="activator" class="white--text" disabled="true">
        <v-icon>add</v-icon>Cadastrar novo
      </v-btn>
      <span class="subheading">Você não possui permissão de cadastrar agente</span>
    </v-tooltip>

    <v-btn class="white--text" color="light-green " v-if="$can('agentes','gerenciarstatus')">
      <v-icon>line_weight</v-icon>Possíveis status
    </v-btn>

    <v-tooltip color="blue-grey" v-if="!$can('agentes','gerenciarstatus')" top>
      <v-btn slot="activator" class="white--text" :disabled="true" color="light-green ">
        <v-icon>line_weight</v-icon>Possíveis status
      </v-btn>
      <span class="subheading">Você não possui permissão de gerenciar status dos agentes</span>
    </v-tooltip>
    <v-divider class="mt-3"></v-divider>

    <div v-if="$can('agentes','listaragentes')">
      <v-card-title style="margin-top:50px;">
        <h1 class="blue-grey--text">Agentes Cadastrados</h1>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          color="red"
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="getAgentes"
        :search="search"
        hide-actions="hide-actions"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.nome }}</td>
          <td class="text-xs-center">{{ props.item.login }}</td>
          <td class="text-xs-center">
            <v-btn class="white--text" fab color="fundo" v-if="$can('agentes','alteraragente')" @click="editItem(props.item)">
              <v-icon>create</v-icon>
            </v-btn>
            <v-tooltip v-if="!$can('agentes','alteraragente')" top>
              <v-btn slot="activator" fab class="white--text" color="fundo" disabled="true" >
                <v-icon>create</v-icon>
              </v-btn>
              <span class="subheading">Você não possui permissão de alterar agente</span>
            </v-tooltip>

            <v-btn class="white--text" fab color="error" v-if="$can('agentes','removeragente')" @click="deleteItem(props.item._id)">
              <v-icon>delete</v-icon>
            </v-btn>

            <v-tooltip v-if="!$can('agentes','removeragente')" top>
              <v-btn slot="activator" class="white--text" color="error" disabled="true">
                <v-icon>delete</v-icon>
              </v-btn>
              <span class="subheading">Você não possui permissão de remover agente</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua busca por &quot;{{ search }}&quot; não retornou resultados.</v-alert>
      </v-data-table>
    </div>
    <h1
      class="text-xs-center headline mt-5"
      v-if="!$can('agentes','listaragentes')"
    >Você não possui permissão de listar agentes</h1>

    <v-snackbar bottom right v-model="snackbar" color="fundo">
      {{ mensagem }}
      <v-btn dark flat @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import Mask from "../../../helpers/Mask";
export default {
  mixins: [Mask],
  data() {
    return {
      tempfone: "",
      snackbar: false,
      mensagem: "",
      dialog: false,
      form: false,
      calendar1: false,
      calendar2: false,
      filtro: {
        dataInicial: null,
        dataFinal: null
      },
      agenteSelected: {
        empresa_id: "",
        _id: "",
        nome: "",
        email: "",
        senha: "",
        telefones: [],
        grupo_id: "",
        endereco: {
          logradouro: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          cep: ""
        }
      },
      search: "",
      headers: [
        { text: "Agente", value: "nome", align: "center" },
        { text: "Email", value: "login", align: "center" },
        { text: "Ação", value: "nome", align: "center" }
      ],
      mensagens: [
        {
          value: false,
          agente: "barreto",
          taxista: "klerison",
          data: "24/12/1997",
          tempototal: "4:00:01"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getAgentes", "getGruposPxTalk"]),
    ...mapGetters(["getUser"]),
    formatDateInicial() {
      if (!this.filtro.dataInicial) return null;
      const [year, month, day] = this.filtro.dataInicial.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateFinal() {
      if (!this.filtro.dataFinal) return null;
      const [year, month, day] = this.filtro.dataFinal.split("-");
      return `${day}/${month}/${year}`;
    },

    validate() {
      return !!(
        this.agenteSelected.nome &&
        /^[a-z0-9._]+@[a-z0-9]+\.[a-z]+(\.[a-z]+)?$/i.test(
          this.agenteSelected.login
        ) &&
        this.agenteSelected.endereco.logradouro &&
        this.agenteSelected.endereco.numero &&
        this.agenteSelected.endereco.bairro &&
        this.agenteSelected.endereco.cidade &&
        this.agenteSelected.endereco.estado &&
        this.agenteSelected.endereco.cep
      );
    }
  },
  methods: {
    ...mapActions([
      "listaGrupoAgentes",
      "listaAgentes",
      "cadastraAgente",
      "alteraAgente",
      "deletaAgente"
    ]),
    novo() {
      this.dialog = true;
      this.agenteSelected = {
        empresa_id: this.getUser.empresa_id,
        nome: "",
        login: "",
        senha: "",
        grupo_id: "",
        telefones: [],
        endereco: {
          logradouro: "",
          numero: "",
          bairro: "",
          cidade: "",
          estado: "",
          cep: ""
        }
      };
      //this.agenteSelected.empresa_id = getUser.empresa_id
    },
    save(taxista) {
      this.cadastraAgente(taxista).then(r => {
        this.dialog = false;
        this.snackbar = true;
        this.mensagem = r.message;
        this.listaAgentes();
      });
    },


    editItem(a) {
      this.form = true;
      this.agenteSelected = Object.assign({}, a);
    },

    update(agente) {
      this.alteraAgente(agente).then(r => {
        this.form = false;
        this.snackbar = true;
        this.mensagem = r.message;
        this.listaAgentes();
      });
    },

    deleteItem(agente)
    {
      if(confirm("Tem certeza?"))
      {
          this.deletaAgente(agente).then(r => {
            this.snackbar = true
            this.mensagem = r.message
            this.listaAgentes()
          })
      }
    },

  },
  mounted() {
    this.listaAgentes()
  }
};
</script>


<style lang="stylus">
.inputdate {
  margin-top: 30px;
  border-bottom: 1px solid #cccccc;
  background-color: #eee;
  padding: 8px;
  border-radius: 3px;
  margin-right: 10px;
}

.painel-pesquisa {
  display: flex;
  justify-content: space-between;
  width: 550px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/pxtalk/Agentes.vue